import { get } from "lodash";

const isProduction =
  (process.env.REACT_APP_NODE_ENV || "").toLowerCase() === "production";

const featureFlags = {
  // Reward-points at checkout (earn preview + use-points discount). Enabled outside
  // production so it can be validated in sandbox before the production rollout.
  rewardPointsCheckout: !isProduction,
  updateOrderStatus: !isProduction,

  // Enable new claim payout flow only in non-production for testing before production rollout
  newClaimPayoutFlow: !isProduction,
};

export function getFeatureFlag(key) {
  return get(featureFlags, key, false);
}
